import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import EmbrapaInova from '../img/icone_pecuaria.svg';
import TermsAndDisclaimer from '../components/popup/TermsAndDisclaimer';
import { hasAcceptedCurrentTerms, saveTermsAcceptance } from '../utils/termsConsent';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../components/language/LanguageSwitcher';

function Termos() {
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (hasAcceptedCurrentTerms()) {
      navigate('/tec_pec', { replace: true });
      return;
    }

    setReady(true);
  }, [navigate]);

  const handleAcceptAllTerms = (acceptedItems) => {
    saveTermsAcceptance(acceptedItems);
    navigate('/tec_pec', { replace: true });
  };

  if (!ready) {
    return null;
  }

  return (
    <main className="flex w-full flex-col items-center mx-auto my-1 px-2 py-3 sm:my-2 sm:w-10/12 sm:p-4 md:w-8/12 lg:w-11/12">
      <div className="language-toolbar"><LanguageSwitcher /></div>
      <header className="mx-auto my-1 flex w-7/12 flex-col justify-center md:w-7/12">
        <img
          src={EmbrapaInova}
          alt={t('logoAlt')}
          fetchPriority="high"
          decoding="async"
          className="mx-auto my-1 w-full"
        />
      </header>

      <TermsAndDisclaimer onAcceptAll={handleAcceptAllTerms} />
    </main>
  );
}

export default Termos;
